
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...contentUri]",
      function () {
        return require("private-next-pages/[...contentUri].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...contentUri]"])
      });
    }
  